// Content-derived React keys; repeated texts get a "#n" suffix so keys stay unique.
export const keyed = (list, toText = String) => {
  const seen = new Map();
  return list.map((item) => {
    const text = toText(item);
    const n = (seen.get(text) || 0) + 1;
    seen.set(text, n);
    return [n > 1 ? `${text}#${n}` : text, item];
  });
};

export const uid = () => `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
